import { FC, useMemo } from 'react';
import { IFraudPatternEvidences, IVisualTextBoxes } from 'src/ts/interfaces/listCheck';
import { PaneNotice } from '../../textBoxes/styles';
import TextBoxesView from '../../textBoxes/TextBoxesPane';
import { textBoxesCopy } from '../../textBoxes/textBoxesCopy';
import { buildModel } from '../../textBoxes/textBoxesModel';
import { evidencesFor } from '../advancedFraudTrendsModel';
import { PatternResults } from '../OverviewTab';
import { ResultLines } from '../styles';
import { PatternViewProps, visualNotice } from './types';

const TextPlacementView: FC<PatternViewProps> = ({
  entry,
  pattern,
  evidence,
  visual,
  proofId,
  pdfUrl,
  pageView,
  showImage,
  onImageAvailable
}) => {
  const notice = visualNotice(entry, visual);
  const model = useMemo(() => {
    if (notice || !visual.data) return null;
    const evidences =
      evidence.status === 'success' ? (evidence.data as unknown as IFraudPatternEvidences) : null;
    return buildModel(visual.data as unknown as IVisualTextBoxes, {
      pattern,
      found: evidencesFor(pattern, evidences),
      providerName: entry.template_name ?? '',
      font: entry.template_font ?? 'sans'
    });
  }, [notice, visual.data, evidence, pattern, entry.template_name, entry.template_font]);

  if (!model) {
    return (
      <div data-testid="advanced-fraud-trends-text-placement">
        <ResultLines>
          <PatternResults pattern={pattern} evidence={evidence} />
        </ResultLines>
        <PaneNotice data-testid="advanced-fraud-trends-page-view-notice">{notice}</PaneNotice>
      </div>
    );
  }

  return (
    <div data-testid="advanced-fraud-trends-text-placement">
      {model.pages.length ? (
        <TextBoxesView
          model={model}
          proofId={proofId}
          pdfUrl={pdfUrl}
          view={pageView}
          showImage={showImage}
          onImageAvailable={onImageAvailable}
        />
      ) : (
        <PaneNotice>{textBoxesCopy.missing}</PaneNotice>
      )}
    </div>
  );
};

export default TextPlacementView;
